import React from 'react';
import styled from 'styled-components';

interface SellerNameProps {
  name: string;
}

export const SellerName = ({ name }: SellerNameProps) => <Text>{name}</Text>;

const Text = styled.span`
  display: block;
  font-size: 14px;
  font-weight: 700;
  color: #404040;
`;
